import ReactGA from "react-ga4"
import { gaCode } from "utils/config"
if (localStorage.getItem("cookiesAccepted") === "true") {
  ReactGA.initialize(gaCode)
}
export default ReactGA
